import { ChatBubbleOutline } from "@mui/icons-material";
import { Skeleton, useMediaQuery } from "@mui/material";
import { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { PageTitle } from "../../../../shared/ui/common";
import ChatRoom from "./chatRoom";
import ChatContactList from "../../components/ChatContactList";
import ChatRoomHeader from "../../components/ChatRoomHeader";
import usePanelChat from "../../hooks/use-panel-chat";
import { useChatDrawerFocus } from "../../hooks/use-chat-drawer-focus";

/** Admin capabilities with the storefront chat's responsive visual shell. */
export default function Chat() {
  const { token, userId } = useSelector((state) => state.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const requestedChatId = Number(id) > 0 ? Number(id) : null;
  const scheme = useSelector((state) => state.themeColor?.themeColor || "light");
  const desktop = useMediaQuery("(min-width:756px)");
  const [search, setSearch] = useState("");
  const [compact, setCompact] = useState(false);
  const [mobileListOpen, setMobileListOpen] = useState(false);
  const listRef = useRef(null);
  const closeList = useCallback(() => setMobileListOpen(false), []);
  const { contacts, allChats, selected, selectContact, opening,
    loading, error, socket, retry, connected } = usePanelChat(token, userId, requestedChatId);
  const filtered = contacts.filter((item) => [item.boothTitle, item.userName, item.email]
    .some((value) => String(value || "").toLowerCase().includes(search.trim().toLowerCase())));
  const showList = desktop || mobileListOpen || !selected?.id;
  useChatDrawerFocus(listRef, !desktop && mobileListOpen && Boolean(selected?.id), closeList);
  async function pickContact(contact) {
    const next = await selectContact(contact);
    if (!next?.id) return;
    setMobileListOpen(false);
    navigate(`/chat/${next.id}`);
  }

  return <>
    <PageTitle title="چت" broadCrumb={[{ title: "تیکت", path: "/chat" }]} />
    <section className="dk-panel-chat dk-chat-theme" data-color-scheme={scheme}
      data-compact={compact ? "true" : "false"} data-has-thread={Boolean(selected?.id)}>
      {error && <div role="alert" className="dk-chat-error">{error}
        <button type="button" onClick={retry}>تلاش مجدد</button>
      </div>}
      {!desktop && mobileListOpen && selected?.id && <button type="button" className="dk-chat-backdrop"
        aria-label="بستن فهرست گفتگوها" onClick={() => setMobileListOpen(false)} />}
      {showList && <aside ref={listRef} className={`dk-chat-sidebar${!desktop && selected?.id ? " is-drawer" : ""}`}
        role={!desktop && selected?.id ? "dialog" : undefined}
        aria-modal={!desktop && selected?.id ? true : undefined} aria-label="فهرست گفتگوها">
        <ChatContactList contacts={filtered} selected={selected} query={search} onQuery={setSearch}
          onSelect={(contact) => { void pickContact(contact); }}
          loading={loading} opening={opening} compact={desktop && compact}
          onToggleCompact={() => setCompact((value) => !value)} onClose={closeList} />
      </aside>}
      {(desktop || selected?.id) && <div className="dk-chat-thread">
        {opening || loading ? <div className="dk-chat-opening"><Skeleton variant="rounded" height="100%" /></div> :
          selected?.id ? <>
            <ChatRoomHeader chat={selected} connected={connected} onOpenList={() => setMobileListOpen(true)} />
            <ChatRoom socket={socket} converstions={allChats[selected.id]?.data || []}
              selected={selected} currentUserId={userId} id={selected.id} connected={connected}
              loading2={!allChats[selected.id] && !error} />
          </> : <div className="dk-chat-empty-thread">
            <ChatBubbleOutline aria-hidden="true" />
            <h2>گفتگوهای شما</h2><p>برای شروع گفتگو یک غرفه را انتخاب کنید.</p>
          </div>}
      </div>}
    </section>
  </>;
}
